/* IDENTITY-20261030 · 身份串联（登录 / 订阅 / 返利中心 三处共用一个身份）
   ────────────────────────────────────────────────────────────────────────────
   侯哥 2026-10-30 要求：
     「不管客户在哪个位置输入了邮箱，这三块自动全部同步」——
     订阅 + 返利赠品 + 登录，任意一处输入邮箱，另外两处都要认出这个人。

   做法：**只做一件事** —— 把"当前这个人的邮箱"交给后台的 /bind。
   后台 identity_bind() 会保证「一人一码」，所以这里不需要任何状态机：
     ① 已登录（theme.liquid 全站下发 window.BB_CUST_EMAIL）→ 本脚本自动绑；
     ② 订阅表单提交 → 调 window.BBIdentity.bind(邮箱)（见 bb-newsletter.js / main-product.liquid）；
     ③ 返利中心 → 它自己的 bb-rewards.js 已经在调 /bind（不用改）。

   🔴 三条硬约束（改之前先读）：
     1. **登录即订阅（2026-10-30 侯哥定）**。登录成功 ⇒ 身份同步 + 进订阅名单，
        客户不用再点第二次。红线只有一条：**主动退订过的人永不复活**
        （后台 subscribe_customer 里拦 UNSUBSCRIBED），这条不受本文件控制。
     2. **同一邮箱只打一次网络**。localStorage 记 bb_id_bound=邮箱，
        命中就完全不发请求 —— 否则每个页面都打一次 /bind，首页会被拖慢。
     3. **绝不影响页面**：全部 try/catch，任何异常都静默；延迟 1.2s 起跑，
        不抢首屏；失败不重试（下次进站自然会再试）。
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var API = (window.BB_API || '').replace(/\/$/, '');
  var EMAIL = String(window.BB_CUST_EMAIL || '').trim().toLowerCase();
  var LSK = 'bb_anon', BOUND = 'bb_id_bound', CODEM = 'bb_id_code';
  var _last = { email: '', ts: 0 };     // 前端去重：同一次提交只打一次网络

  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lss(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ck(k) {
    var m = document.cookie.match('(^|;)\\s*' + k + '=([^;]+)');
    return m ? decodeURIComponent(m[2]) : null;
  }
  function setck(k, v, d) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + ';path=/;max-age=' + (d * 86400) + ';samesite=lax';
    } catch (e) {}
  }
  function uid() {
    var a = 'abcdefghijklmnopqrstuvwxyz0123456789', s = '';
    for (var i = 0; i < 16; i++) s += a.charAt(Math.floor(Math.random() * a.length));
    return s;
  }
  /* 与 bb-referral.js 完全同一套 anon 规则（同一个 key、同一个 cookie），
     否则两个脚本会各自生成一个 anon，后台看起来像两个人 */
  function anon() {
    var k = ls(LSK) || ck('bb_anon');
    if (!k) k = uid();
    lss(LSK, k); setck('bb_anon', k, 365);
    return k;
  }

  function buildLink(code) {
    // 与 ERP 后台给的链接同形：?op=..&ref=..（op 后台按邮箱自己补）
    return 'https://' + (window.BB_PUBLIC_DOMAIN || 'beibelle74.com') + '/?ref=' + encodeURIComponent(code);
  }

  /** 把邮箱交给后台做身份归并。返回 Promise<{ok,code,link}>（永不 reject） */
  function bind(email, opts) {
    var e = String(email || '').trim().toLowerCase();
    opts = opts || {};
    if (!e || e.indexOf('@') < 1 || !API) {
      return Promise.resolve({ ok: false, reason: 'no-email-or-api' });
    }
    /* 同一次提交可能被两个脚本各调一次（brand.js 与 bb-newsletter.js 都在监听
       .news__form 的 submit）。3 秒内同一邮箱只发一次，免得白打两遍后台
       （后台第一次就要建折扣码，2 秒级）。
       🔴 必须把**同一个 Promise 还回去**，不能返回一个空壳 ——
          调用方（rewards 的 fillLink）拿到空对象会当成"绑定失败"，
          于是链接位一直显示 Creating…。 */
    var now = Date.now();
    if (_last.email === e && now - _last.ts < 3000 && _last.p) {
      return _last.p;
    }
    _last = { email: e, ts: now, p: null };
    var body = JSON.stringify({
      anon_id: anon(),
      email: e,
      subscribe: !!opts.subscribe        // 默认 false：登录/订阅入口都不擅自改 consent
    });
    var url = API + '/bind';
    var p;
    if (opts.beacon && navigator.sendBeacon) {
      /* 订阅表单是原生 POST 整页跳转，fetch 会被中断 ⇒ 必须 sendBeacon。
         拿不到返回值，但不影响结果：下次进站登录钩子会补到同样的结论（服务端幂等）。 */
      try {
        var blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(url, blob);
        lss(BOUND, e);
        p = Promise.resolve({ ok: true, beacon: true });
      } catch (err) {
        p = Promise.resolve({ ok: false, reason: 'beacon-failed' });
      }
    } else {
      var ctl = window.AbortController ? new AbortController() : null;
      var t = setTimeout(function () { if (ctl) ctl.abort(); }, opts.timeout || 12000);
      p = fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        signal: ctl ? ctl.signal : undefined
      }).then(function (r) { return r.json(); }).then(function (d) {
        clearTimeout(t);
        if (d && d.ok && d.code) {
          lss(BOUND, e);
          lss(CODEM, d.code);
          try {
            window.dispatchEvent(new CustomEvent('bb:identity', { detail: d }));
          } catch (err) {}
          applyOffer(d);      /* OFFER-FE-20261101：后端说该给几折，这里就落几折 */
        }
        return d || { ok: false };
      }).catch(function (err) {
        clearTimeout(t);
        return { ok: false, reason: (err && err.name) || 'network' };
      });
    }
    _last.p = p;
    return p;
  }

  /** 订阅成功回跳后反查一次真实 consent（只读，后台不会替客户改订阅状态）
      rewards 页和订阅框要立刻显示"已订阅"，不能等下一次登录。 */
  function optinSync(email) {
    var e = String(email || '').trim().toLowerCase();
    if (!e || e.indexOf('@') < 1 || !API) return;
    var body = JSON.stringify({ email: e });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(API + '/optin/sync', new Blob([body], { type: 'application/json' }));
        return;
      }
    } catch (err) {}
    try {
      fetch(API + '/optin/sync', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true
      });
    } catch (err) {}
  }

  window.BBIdentity = {
    bind: bind,
    optinSync: optinSync,
    anon: anon,
    email: EMAIL,
    bound: function () { return ls(BOUND) === EMAIL; },
    code: function () { return ls(CODEM) || ''; },
    link: function () { var c = ls(CODEM); return c ? buildLink(c) : ''; }
  };

  /* ── ② 订阅成功回跳：统一收口 ────────────────────────────────────────
     三个订阅入口（首页 join / 页面底部 newsletter / 商品页）**都把待确认邮箱
     写在 sessionStorage 的 bb_pending_email**（值本身同名，这是巧合但正好用得上）。
     放在这里统一处理，好处是不依赖"某个 section 有没有加载"：
       · 记 bb_sub_email → 返利中心能靠它认领（未登录也有链接）；
       · 反查真实 consent（只读）→ 返利中心/订阅框立刻显示"已订阅"；
       · 顺手把身份建好（后台幂等，订阅时其实已经建过）。
     ⚠️ 必须在任何 location.replace 之前跑：newsletter.js 订阅成功后会跳
        /discount/FRIEND15，跳走就来不及了 —— 本脚本是 head 里的 defer，先执行。 */
  function handlePosted() {
    if (!/[?&]customer_posted=true/.test(location.search)) return;
    var em = '';
    try { em = (sessionStorage.getItem('bb_pending_email') || '').trim().toLowerCase(); } catch (e) {}
    if (!em) em = EMAIL;
    if (em.indexOf('@') < 1) return;
    try { localStorage.setItem('bb_sub_email', em); } catch (e) {}
    optinSync(em);
    bind(em, { subscribe: false });
  }

  /* ── ③ 全站登录自动绑 + 订阅 ────────────────────────────────────────
     条件：已登录（有 customer.email）+ 本浏览器还没为这个邮箱绑过。
     只打一次网络；失败静默，下次进站再说。

     🔴 2026-10-30 侯哥定：**登录即订阅**（subscribe:true）。
        为什么这样才对：
          · 返利中心页面本来就写着「Signing in also puts you on our new-drop
            emails」—— 只让那一个页面订阅、别的入口不订阅，是自相矛盾；
          · 客户少填一次、少点一次，品牌才拿得到邮箱做后续自动化；
          · 本站是 SINGLE_OPT_IN，不会给客户多塞一封"请确认订阅"的邮件。
        唯一红线在后台：**主动退订过的人（UNSUBSCRIBED）永远不复活**，
        见 api.py 的 subscribe_customer()。想整体关掉：config.json 加
        {"auto_subscribe_on_login": 0}，前端不用改。 */
  /* OFFER-FE-20261101：把后端算出来的档位落到浏览器，并让 discount-pick 去跳码。
     为什么单独抽出来：登录用户的 bind 只在「本浏览器没绑过」时才发，
     老用户回来一次请求都没有，就拿不到 offer ⇒ 这里补一条只读查询。 */
  function applyOffer(d) {
    try {
      if (!d || !d.ok) return;
      if (d.offer) {
        lss('bb_offer', String(d.offer).toUpperCase());
        lss('bb_tier', String(d.tier || ''));
        /* 先广播再跳转：订阅区的"你已进名单"提示要用同一口径
           （NO-20-20261101：全站只有订阅 10%） */
        try { window.dispatchEvent(new CustomEvent('bb:offer', { detail: d })); } catch (e) {}
        try { if (window.BB_APPLY_OFFER) window.BB_APPLY_OFFER(true); } catch (e) {}
      }
    } catch (e) {}
  }

  function fetchOffer() {
    if (!EMAIL || !API) return;
    try {
      fetch(API + '/offer?email=' + encodeURIComponent(EMAIL), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) {
            if (d.offer) { applyOffer({ ok: true, offer: d.offer, tier: d.tier }); }
            else {
              /* 后端明确说"没有该给的码"（回访客未订阅 / Admin 不可用）：
                 清掉旧档位，别让上一次的 NEW20 一直留在浏览器里继续生效 */
              try { localStorage.removeItem('bb_offer'); } catch (e) {}
            }
          }
        })
        .catch(function () {});
    } catch (e) {}
  }

  function autobind() {
    if (!EMAIL || !API) return;
    if (ls(BOUND) === EMAIL) { fetchOffer(); return; }   // 已绑过：只补查档位，不重复绑
    bind(EMAIL, { subscribe: true, timeout: 15000 });
  }

  function start() {
    try { handlePosted(); } catch (e) {}
    setTimeout(autobind, 1200);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
